/* ═══════ TÉMOIGNAGES — Progression émotionnelle ═══════
   1. Résistance / Scepticisme
   2. Identification / Peur / Doute
   3. Ouverture / Trouver sa place
   4. Libération / Lâcher prise
   5. Transformation / Après
   6. Puissance du collectif
   7. Dimension spirituelle / Sens
   8. Clôture / Transmission / Miroir
   ═══════════════════════════════════════════════════════ */

const testimonials = [
  // ─── 1. RÉSISTANCE / SCEPTICISME ───
  {
    name: "André",
    city: "Margencel",
    text: "Je suis venu en crabe. À reculons. C'était une idée de ma femme au départ. Je l'ai écoutée, je suis venu. Et j'ai bien fait. Ce qui m'a bouleversé ici, c'est la tolérance. Aucune pression, juste la sensation d'être à ma place. Chaque personne est différente et apporte quelque chose à la cohésion du groupe, c'est fou. De belles rencontres et des moments de partage. Forts. Vrais. Inattendus.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/u9uxavlm_DSC01165.jpg",
  },

  // ─── 2. IDENTIFICATION / PEUR / DOUTE ───
  {
    name: "Nathalie",
    city: "Genève",
    text: "Je suis remplie de gratitude. Je venais avec l'esprit et le cœur ouverts, mais sans attente particulière... J'avais même un peu peur du groupe. Et j'ai été totalement conquise. Ce qui m'a bluffée, c'est tout ce que j'ai appris. Des outils que j'ai déjà pu utiliser. Des rencontres incroyables qui vont persister dans le temps. Je repars riche. Humaine. Outillée.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/qesmwg9a_DSC00541.jpg",
  },
  {
    name: "Estelle",
    city: "Évian",
    text: "Je ne parle pas en groupe. Ce n'est pas mon truc. Mais là... je suis plus sortie de ma zone de confort en quatre jours que ces trois dernières années. Et c'est exactement ce que je voulais. Je suis venue sans attente, et je repars avec des réponses. Et peut-être même une petite envie de recommencer. Cocon m'a beaucoup apporté, c'est au-delà des mots. Il faut le vivre pour le comprendre.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/qltqqw8t_DSC00730.jpg",
  },

  // ─── 3. OUVERTURE / TROUVER SA PLACE ───
  {
    name: "Maëva",
    city: "Genève",
    text: "Avant de venir, c'était compliqué depuis un moment... difficile de me sentir à ma place, d'oser rester en moi. Ici, j'ai été acceptée dès le premier jour, avec mes bizarreries, ma sensibilité, mes failles. J'ai été remplie. Ce cocon, c'est un endroit où on peut juste être. Je repars avec un petit déclic : ce n'est pas grave de ne pas savoir comment... ça se fait quand même.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/uk1kwjk4_DSC03817.jpg",
  },
  {
    name: "Lydie",
    city: "Margencel",
    text: "Nous, on est un peu sauvages. On vit ensemble, à la montagne, dans notre bulle. Les groupes, c'est pas trop notre truc. Mais ici... on s'est senti·e·s à notre place. Accueilli·e·s sans avoir à jouer un rôle. Même la constellation – j'y croyais pas – j'ai vécu un truc fort. Ce cocon, c'est des rencontres sans masques, sans fard, sans filtre. C'est de l'humain, du vrai. Et ça, ça fait un bien fou, car ça devient trop rare de nos jours.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/xvl99mk7_DSC02263.jpg",
  },

  // ─── TRANSITION 1 ───
  { transition: "Chaque parcours est différent.\nMais quelque chose revient toujours." },

  // ─── 4. LIBÉRATION / LÂCHER PRISE ───
  {
    name: "Julie",
    city: "Martigues",
    text: "J'ai appris de chacun·e de vous et je repars inspirée. C'est un rappel : en montrant nos failles, on partage aussi notre lumière et notre force. À travers vos bizarreries, vous m'avez donné la permission d'être, moi aussi, bizarre. Ici, j'ai pu être pleinement et librement moi. Cocon, c'est un endroit complètement fou, magnifique... et sécurisé.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/s411c027_DSC03061.jpg",
  },
  {
    name: "Mélissa",
    city: "",
    text: "Le plus grand voyage ? C'est celui de la tête au cœur. J'ai pris ce bus il y a des années, et ici j'ai compris pourquoi. Grâce à vous, j'ai vu une part de moi en chacun·e d'entre vous. Et j'ai enfin pu tomber le gilet pare-balles, être véritablement moi. Je veux transmettre, sans peur, avec confiance. Et ça commence maintenant.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/4qwriopt_DSC03541.jpg",
  },

  // ─── 5. TRANSFORMATION / APRÈS ───
  {
    name: "Rémi",
    city: "Otonville",
    text: "Ce cocon, c'est une piqûre de rappel. Ni mieux, ni moins bien que l'an dernier. Juste différent. Je repars le cœur rempli de vos sourires, de votre bienveillance. Depuis ma première retraite, je me forme au Reiki. Cocon a rendu cela possible. Il suffit d'ouvrir son cœur... et ça se propage.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/soz6vryw_DSC04035.jpg",
  },
  {
    name: "Laure",
    city: "",
    text: "J'ai eu la chance de faire le premier Cocon. Celui-ci, c'était Cocon 2. Et ça marque tout autant. Les constellations familiales m'ont beaucoup marquée, il y aura un avant et un après. Mon chemin s'agrandit, et vous en faites tous partie. L'effet Valouse ? Ça m'a portée neuf mois... et je sens que ça continue.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/9uzacqxa_DSC02543.jpg",
  },
  {
    name: "Marie",
    city: "",
    text: "J'ai moins pleuré cette année. Je guéris. J'évolue. J'avais pris un tas de mouchoirs... et en fait, je repars avec. Je les ai partagés avec mes camarades cette année. Ce week-end, c'était encore une piqûre de rappel. À chaque fois, on repart avec des outils. Faut juste s'autoriser à les utiliser. Ce n'est pas que pour cette semaine, c'est pour tous les jours.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/cxgi48pl_DSC06287.jpg",
  },

  // ─── TRANSITION 2 ───
  { transition: "Ce qui se vit ici ne s'explique pas.\nMais ça se reconnaît." },

  // ─── 6. PUISSANCE DU COLLECTIF ───
  {
    name: "Dominique",
    city: "Ranspach",
    text: "L'an dernier, c'était les grandes eaux. Une débâcle émotionnelle qui m'a ouvert la voie. Cette année, c'est différent... mais tout aussi fort. Je repars remplie encore une fois. Ce cocon, c'est une force collective rare. On a tous nos défis, mais ensemble, on est puissant·e·s. Comme dit Jeinar : seul·e, tu peux tout. Ensemble... on peut encore plus.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/bs5f1a6a_DSC00331.jpg",
  },
  {
    name: "Pascale",
    city: "Lens",
    text: "Je suis un peu sauvage. M'intégrer dans un groupe, c'est compliqué. Mais chaque année, je reviens. Et je suis remplie. Ce que transmettent les coconeuses, c'est presque inimaginable. Et les autres participant·e·s m'ont également énormément enrichie. Ça me donne envie d'aller vers les autres, même si c'est pas simple... ça vaut le coup. On ne chemine pas seul·e à Cocon. Et ça faisait longtemps que je n'avais pas ri comme j'ai ri ici.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/pfnks1wg_DSC02589.jpg",
  },

  // ─── 7. DIMENSION SPIRITUELLE / SENS ───
  {
    name: "Georges",
    city: "Paris",
    text: "Je me sentais perdu, je suis arrivé à Cocon par hasard... Enfin, c'est ce que je croyais. J'ai rigolé, j'ai partagé... et surtout, je me suis retrouvé. Je repars heureux. C'était un vrai rendez-vous.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/kom0u2qb_DSC03096.jpg",
  },
  {
    name: "Isabelle",
    city: "Paris",
    text: "Ici, j'ai enfin pu ressentir cette vibration, ce que je tente d'exprimer depuis si longtemps... et qui restait bloqué. Grâce à vous, j'y vois plus clair. Vous êtes des êtres de lumière. Et vous m'aidez à le devenir moi aussi.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/4xhzrz6a_DSC02232.jpg",
  },
  {
    name: "Sylviane",
    city: "Rhodes-Saint-Genèse",
    text: "Je suis un sage, mais parfois il faut savoir descendre de son tabouret. J'ai suivi mon propre rythme. J'ai lu, j'ai dormi, j'ai choisi. Et au milieu de mon chemin, j'ai trouvé ici une escale lumineuse.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/lce4wc84_DSC00534.jpg",
  },

  // ─── TRANSITION 3 ───
  { transition: "Certaines voix portent le cercle.\nLes voici." },

  // ─── 8. CLÔTURE / TRANSMISSION / MIROIR ───
  {
    name: "Jeinar",
    city: "Bali",
    text: "Dès le premier soir, j'ai senti ces moments si particuliers de réalisation : cette colonne vertébrale qui se redresse, ce souffle qui dit ça y est, je suis au bon endroit. Chaque jour, une prise de conscience comme une vague. Je repars grandie, emplie de gratitude.",
    photo: "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/ehndqm9a_DSC06266.jpg",
  },
  {
    name: "Valérie",
    city: "Genève",
    text: "C'était ma troisième fois. Et à chaque fois, je découvre, je redécouvre... des âmes uniques. Ici, je suis telle que je suis, et je vois que ça plaît. Même dans ma folie. Ce que je ramène avec moi ? L'envie de continuer à diffuser cette lumière. Vous m'avez encouragée, réconfortée, et donné la certitude : je suis sur le bon chemin.",
    photo: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/as2yuj7o_WhatsApp%20Image%202026-02-01%20at%2018.53.40.jpeg",
  },
  {
    name: "Deborah",
    city: "Hégenheim",
    text: "Ce que je vis à chaque fois ici, ce sont des rencontres... des personnes qui deviennent une famille en deux jours. On ne se connaissait pas, et maintenant je vous emmène tous dans mon cœur. Cette semaine, vous m'avez inspirée, vous avez nourri ma passion. Chacun·e à votre façon. Je suis heureuse de voir tant de transformations. Tant de beauté. Tant d'amour.",
    photo: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/6r9rpmdm_DSC01487.jpg",
  },
  {
    name: "Maïté",
    city: "Genève",
    text: "Parfois, je me demande si je suis juste... ou complètement à côté. Et là, avec tout ce qu'on a partagé, je suis pleine d'émotions. Ça me montre que c'est juste. Même si, dehors, j'ai parfois l'impression d'être un extraterrestre... Ici, j'ai eu une expérience extraordinaire. Je sens que je rentre sur un boulevard, et je ne vais pas m'arrêter. J'ai la foi plus que jamais que c'est ça qui est juste pour moi... et juste de le partager.",
    photo: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/64bo4q6r_DSC00675.jpg",
  },
  {
    name: "Mylène / Âme Diva",
    city: "Annecy",
    text: "J'adore cette richesse en chacun·e. J'adore cette unicité, cette famille, ces couples, ces personnes seules qui arrivent ici... et qui se transforment. Vous êtes magiques. J'ai vécu cette retraite comme une consécration. Vous m'avez apporté énormément. Et vraiment... Merci d'être chacun·e qui vous êtes dans votre couleur, et merci d'avoir quitté votre quotidien pour venir à cette rencontre.",
    photo: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/2d7ag7eo_DSC00736.jpg",
  },
];

export default testimonials;
